import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Col, Empty, Pagination, Row, Tag, Tooltip } from "antd";
import { useActionEffortRefine, useEffort } from "hook/draft/effort/useEffort";
import moment from "moment";
import DialogContent from "./component/dialog_content";
import { useSearchParams } from "react-router-dom";

const TabPass = () => {
  const { data } = useActionEffortRefine();
  const { pass } = useEffort();
  // -------------------------- VAR -----------------------------
  const [searchParams, setSearchParams] = useSearchParams();
  const pageNo = searchParams.get("page") || "1";
  const page = parseInt(pageNo);
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handlePage = (page) => {
    const object = { viewOpenScore: true, page, tab: "pass" };
    setSearchParams(object);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderPagination = () => (
    // Center pagination on mobile, align right on desktop
    <Pagination
      rootClassName="flex justify-center md:justify-end"
      defaultCurrent={page}
      total={pass || 0}
      onChange={handlePage}
      pageSize={10}
      size="small"
    />
  );

  const renderPassIcon = ({ item }) => {
    return (
      <div className="flex-shrink-0">
        <Tooltip title="Đoạn hội thoại đã đủ tiêu chuẩn">
          <CheckCircleOutlined className="text-2xl text-green-500" />
        </Tooltip>
      </div>
    );
  };

  const renderTime = ({ item }) => {
    const createAt = item?.createAt;
    const labelCreateAt = moment(createAt?.toDate()).format(
      "DD/MM/YYYY HH:mm:ss",
    );
    return <div className="text-sm italic text-gray-500">{labelCreateAt}</div>;
  };

  const renderTag = ({ item }) => (
    // On mobile, tags are in a wrapping row. On tablet+, they stack vertically.
    <div className="flex w-full flex-row flex-wrap justify-center gap-2 md:w-auto md:flex-col">
      <Tag className="min-w-[80px] text-center" color="green">
        Exp: {item?.exp}
      </Tag>
      <Tag className="min-w-[80px] text-center" color="blue">
        Effort: {item?.effort}
      </Tag>
      <Tag className="min-w-[80px] text-center" color="orange">
        Ease: {item?.ease}
      </Tag>
      <Tag className="min-w-[80px] text-center" color="red">
        Mistake: {item?.mistake}
      </Tag>
    </div>
  );
  // -------------------------- MAIN ----------------------------

  if (!data || data?.length === 0) {
    return (
      <div className="flex min-h-[200px] items-center justify-center">
        <Empty description="Không có dữ liệu" />
      </div>
    );
  }

  return (
    <div>
      {/* Header Row */}
      <Row gutter={[0, 16]} align="middle" className="mb-4">
        <Col lg={12} md={12} xs={24}>
          <b className="text-base">Danh sách nhận điểm</b>
        </Col>
        <Col lg={12} md={12} xs={24}>
          {renderPagination()}
        </Col>
      </Row>

      {/* List */}
      <Row gutter={[0, 16]}>
        {data?.map((item) => {
          const key = item?.id;
          return (
            <Col key={key} span={24}>
              {/* --- Responsive List Item --- */}

              <div className="flex flex-col items-center gap-4 rounded-lg border border-gray-200 p-4 shadow-sm md:flex-row md:items-start">
                {renderPassIcon({ item })}

                <div className="flex w-full flex-grow flex-col items-center gap-2 text-center md:items-start md:text-left">
                  <DialogContent data={item} />
                  {renderTime({ item })}
                </div>

                {/* Stats Tags: Appears last on all screens */}
                {renderTag({ item })}
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default TabPass;
